import { render, staticRenderFns } from "./RateList.vue?vue&type=template&id=4977c420&scoped=true&"
import script from "./RateList.vue?vue&type=script&lang=js&"
export * from "./RateList.vue?vue&type=script&lang=js&"
import style0 from "./RateList.vue?vue&type=style&index=0&id=4977c420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977c420",
  null
  
)

export default component.exports